const { REACT_APP_API_BASE_URL } = process.env;

export const getRequirementsAll = (token, query) => new Promise((resolve, reject) => {
  const queryParams = new URLSearchParams({
    results: 10,
    ...query
  }).toString();
  
  const request = new Request(REACT_APP_API_BASE_URL + '/requirements?' + queryParams, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const getRequirements = (token, query) => new Promise((resolve, reject) => {
  const queryParams = new URLSearchParams({
    results: 10,
    ...query
  }).toString();
  
  const request = new Request(REACT_APP_API_BASE_URL + '/requirements/all' + queryParams, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const getRequirement = (token, id) => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/requirements/' + id, {
    method: 'GET',
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const createRequirement = (token, payload) => {
  const request = new Request(`${REACT_APP_API_BASE_URL}/requirements/createNewRequirement`, {
    method: 'POST',
    headers: {
      'Authorization': `Bearer ${token}`,
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  });

  return fetch(request);
};

export const updateRequirement = (token, id, requirement) => new Promise((resolve, reject) => {
  const request = new Request(REACT_APP_API_BASE_URL + '/requirements/' + id, {
    method: 'PUT',
    body: JSON.stringify({ requirement }),
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const createRequirementMessage = (token, id, data) => new Promise((resolve, reject) => {
  const request = new Request(`${REACT_APP_API_BASE_URL}/requirements/${id}/message`, {
    method: 'POST',
    body: JSON.stringify({ data }),
    headers: {
      'Authorization': 'Bearer ' + token,
      'Content-Type': 'application/json'
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});

export const uploadRequirementMessageFile = (token, id, file) => new Promise((resolve, reject) => {
  const data = new FormData();
  data.append('file', file);

  const request = new Request(`${REACT_APP_API_BASE_URL}/requirements/${id}/message/file`, {
    method: 'POST',
    body: data,
    headers: {
      'Authorization': 'Bearer ' + token,
    }
  });
  fetch(request)
  .then(response => resolve(response))
  .catch(err => reject(err))
});
